// extracted by mini-css-extract-plugin
export var button = "_a6-7";
export var buttonRow = "_a6-6";
export var fadeIn = "_a6-1";
export var gradient = "_a6-0";
export var panel = "_a6-2";
export var panelIn = "_a6-3";
export var subtitle = "_a6-5";
export var title = "_a6-4";